import React, { createContext, useState, useEffect } from 'react';

// 1. O Contexto que será consumido
export const ClientContext = createContext({ 
    selectedValue: {}, 
    setSelectedValue: () => {} 
});

// 2. O Provider (usa Hooks)
export const ClientProvider = ({ children }) => {
  const [selectedValue, setSelectedValue] = useState({}); 
  
  // Opcional: Aqui você pode colocar a lógica de sincronização com localStorage 
  // que discutimos anteriormente.
  
  return (
    <ClientContext.Provider value={{ selectedValue, setSelectedValue }}>
      {children}
    </ClientContext.Provider>
  );
};

// Se for usar o Contexto em componentes de função, use este hook:
// export const useSelectValue = () => useContext(ClientContext);